<template>
  <div class="app-main-content kef-docking">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%">
        <el-tab-pane :label="$t('SystemDocking.BatchImportOrders')" name="tabBatchImportOrder" :lazy="true">
          <tab-batch-import-order />
        </el-tab-pane>
        <el-tab-pane :label="$t('SystemDocking.BatchExportOrders')" name="tabBatchExportOrder" :lazy="true">
          <tab-batch-export-order />
        </el-tab-pane>
        <el-tab-pane :label="$t('SystemDocking.BatchExportBills')" name="tabBatchExportBill" :lazy="true">
          <tab-batch-export-bill />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import TabBatchImportOrder from '@/views/cargo/v0/SystemDocking/Kef/tabBatchImportOrder'
import TabBatchExportOrder from '@/views/cargo/v0/SystemDocking/Kef/tabBatchExportOrder'
import TabBatchExportBill from '@/views/cargo/v0/SystemDocking/Kef/tabBatchExportBill'
export default {
  name: 'Kef',
  components: { TabBatchExportBill, TabBatchExportOrder, TabBatchImportOrder },
  data() {
    return {
      activeTabName: 'tabBatchImportOrder'
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/element-variables.scss";
.kef-docking{
  .el-divider__text.is-left{
    background-color: $--background-color-base;
  }
  .orange {
    color: $--color-warning;
  }
  .el-form-item {
    margin-bottom: 10px!important;
  }
}

</style>
